import { render, staticRenderFns } from "./consent.vue?vue&type=template&id=53e74869&"
import script from "./consent.vue?vue&type=script&lang=js&"
export * from "./consent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "consent.vue"
export default component.exports